import React, { useState } from "react";
import contactStyle from "./contactStyle";
import { Box, Button, TextField, useTheme } from "@mui/material";
import _ from "lodash";
import Grid from "@mui/material/Grid";
import { Call } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import { getProductData, getResponsibleInstitutes } from "../../services/Product/ProductService/productService";
import InputAdornment from "@mui/material/InputAdornment";

import { ProductUnion } from "../../types/ProductUnion";

type ExtendedContactProps = {
  product: ProductUnion;
};
const ExtendedContact = ({ product }: ExtendedContactProps) => {
  const [showMore, setShowMore] = useState(false);

  if (
    ![
      "divorce",
      "settlement",
      "traffic",
      "trafficAccident",
      "eventContract",
      "membershipContract",
      "otherContract",
      "providerContract",
      "dataLeakContract",
      "purchaseContract",
      "serviceContract",
      "subscriptionContract",
      "travelContract",
      "vehicleContract",
      "rentalContract",
    ].includes(product.productClassName) ||
    product.leadStatus < getProductData(product.productClassName, "minimumCaseStatus")
  ) {
    return null;
  }

  const { courtPath, authorityPath } = getResponsibleInstitutes(product);

  return (
    <>
      {showMore && (
        <>
          {product.productClassName === "traffic" && (
            <>
              <Box sx={contactStyle.headline}>Zuständige Behörde</Box>
              <TextField
                multiline
                label={"Zuständige Behörde"}
                value={
                  (_.get(product, authorityPath + ".name") || "") +
                  "\n" +
                  (_.get(product, authorityPath + ".department") || "") +
                  "\n" +
                  (_.get(product, authorityPath + ".subDepartment") || "")
                }
                disabled
              />
              <TextField
                label={"Faxnummer Behörde"}
                value={_.get(product, authorityPath + ".fax") || ""}
                disabled
                slotProps={{
                  input: {
                    startAdornment: <InputAdornment position="start">+49</InputAdornment>,
                  },
                }}
              />
              <Grid
                container
                sx={{
                  alignItems: "flex-start",
                }}
              >
                <Grid size={10}>
                  <TextField
                    label={"Telefonnummer Behörde"}
                    value={_.get(product, authorityPath + ".telephone") || ""}
                    disabled
                  />
                </Grid>
                <Grid sx={contactStyle.callGridItem} size={2}>
                  <IconButton
                    color={"secondary"}
                    sx={contactStyle.callIcon}
                    href={"tel:" + _.get(product, authorityPath + ".telephone")}
                    disabled={!_.get(product, authorityPath + ".telephone")}
                    size="large"
                  >
                    <Call />
                  </IconButton>
                </Grid>
              </Grid>
            </>
          )}
          <Box sx={contactStyle.headline}>Zuständiges Gericht</Box>
          <TextField label={"Zuständiges Gericht"} value={_.get(product, courtPath + ".name") || ""} disabled />
          <TextField
            label={"Faxnummer Gericht"}
            value={_.get(product, courtPath + ".fax") || ""}
            disabled
            slotProps={{
              input: {
                startAdornment: <InputAdornment position="start">+49</InputAdornment>,
              },
            }}
          />
          <Grid
            container
            sx={{
              alignItems: "flex-start",
            }}
          >
            <Grid size={10}>
              <TextField
                label={"Telefonnummer Gericht"}
                value={_.get(product, courtPath + ".telephone") || ""}
                disabled
              />
            </Grid>
            <Grid sx={contactStyle.callGridItem} size={2}>
              <IconButton
                color={"secondary"}
                sx={contactStyle.callIcon}
                href={"tel:" + _.get(product, courtPath + ".telephone")}
                disabled={!_.get(product, courtPath + ".telephone")}
                size="large"
              >
                <Call />
              </IconButton>
            </Grid>
          </Grid>
        </>
      )}
      <Grid
        container
        sx={[
          contactStyle.moreButton,
          {
            justifyContent: "center",
          },
        ]}
      >
        <Grid>
          <Button
            onClick={() => {
              setShowMore(!showMore);
            }}
          >
            {showMore ? "Weniger" : "Mehr"} Anzeigen
          </Button>
        </Grid>
      </Grid>
    </>
  );
};
export default ExtendedContact;
